/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ScholarshipfileapprovalSharedDocumentApprovalStatusList200,
  GetApiV1ScholarshipfileapprovalSharedDocumentApprovalStatusList401,
  GetApiV1ScholarshipfileapprovalSharedDocumentApprovalStatusList500,
  GetApiV1ScholarshipfileapprovalSharedDocumentApprovalStatusListQueryParams,
  GetApiV1ScholarshipfileapprovalSharedDocumentApprovalStatusListQueryResponse,
} from "../../types/scholarshipFileApprovalSharedController/GetApiV1ScholarshipfileapprovalSharedDocumentApprovalStatusList.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";

export const getApiV1ScholarshipfileapprovalSharedDocumentApprovalStatusListQueryParamsSchema =
  z.object({
    culture: z.string().default("pt-BR"),
  }) as unknown as ToZod<GetApiV1ScholarshipfileapprovalSharedDocumentApprovalStatusListQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ScholarshipfileapprovalSharedDocumentApprovalStatusList200Schema =
  z.array(
    z.lazy(() => dropDownListViewModelSchema),
  ) as unknown as ToZod<GetApiV1ScholarshipfileapprovalSharedDocumentApprovalStatusList200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ScholarshipfileapprovalSharedDocumentApprovalStatusList401Schema =
  z.any() as unknown as ToZod<GetApiV1ScholarshipfileapprovalSharedDocumentApprovalStatusList401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ScholarshipfileapprovalSharedDocumentApprovalStatusList500Schema =
  z.any() as unknown as ToZod<GetApiV1ScholarshipfileapprovalSharedDocumentApprovalStatusList500>;

export const getApiV1ScholarshipfileapprovalSharedDocumentApprovalStatusListQueryResponseSchema =
  z.lazy(
    () =>
      getApiV1ScholarshipfileapprovalSharedDocumentApprovalStatusList200Schema,
  ) as unknown as ToZod<GetApiV1ScholarshipfileapprovalSharedDocumentApprovalStatusListQueryResponse>;
